<script>
import Component from '~/sites/soh/pages/page/_slug'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/stranka/:slug',
      de: '/seite/:slug',
      en: '/page/:slug',
      sk: '/stranka/:slug',
    },
  },
}
</script>
